import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ServiceProviderCallToActionAppResource from "./ServiceProviderCallToActionAppResource";

class ServiceProviderCallToActionTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-call-to-action-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/calls/tos/actions/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'isEnabled',
            'callToActions',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            callToActions: ServiceProviderCallToActionAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            isEnabled: {
                type: 'boolean',
            },
        };
    }
}

export default ServiceProviderCallToActionTypeAppResource;
